import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';

import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import './Step2.scss';
import * as actions from '../../../actions/index';

import * as _actionsFilters from '../../../actions/filters';
import * as _actionsSujet from '../../../actions/sujet';
import IndustriesSelect from '../../../components/IndustriesSelect';
import BottomNavigation from '../../../components/BottomNavigation';
import { IBoxCardSizes } from '@repo/apg-ui';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';
import { SchemaIndustry } from '@repo/legacy-commerce-api';

interface Props {
  locales: any;
  dispatch: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsJourney: any;
  actionsFilters: typeof _actionsFilters;
  actionsSujet: typeof _actionsSujet;
  history: any;
  industry: any;
  industries: any;
  industriesByKey: any;
  big5Industry: any;
  big5Industries: Record<string, SchemaIndustry>;
  validationMessageConfig: any;
  possibleBookingDates: any;
}

const Step2 = (props: Props) => {
  return (
    <div className='step2'>
      <div>
        <div className='header'>
          <h4 className='title-journey mb-0'>
            <FormattedMessage
              id='ec.journey02.step02.header'
              defaultMessage='Unter welche Inhalts-Kategorie fällt Ihre Werbung?'
            />
          </h4>
        </div>

        <div className='d-flex mt-4 flex-row flex-wrap mapContainer'>
          <p className='text-left align-self-center me-48 fw-bold w-100 sub-title'>
            <FormattedMessage
              id='ec.journey02.step02.text'
              defaultMessage='Meine Werbebotschaft enthält einen der folgenden Inhalte:'
            />
          </p>
        </div>

        <div className='d-flex full-card-width flex-column'>
          <IndustriesSelect isShowIcons={false} cardSize={IBoxCardSizes.SmallCard} />
        </div>
        <BottomNavigation
          isDisabled={!props.userDataEC.industry}
          nextCallback={() => {
            const {
              actionsFilters: { updateIndustryAndClearBasket },
            } = props;
            const { industry } = props.userDataEC;
            updateIndustryAndClearBasket(industry);
          }}
          changeAgencyInfoPanelVisibility={(value) => {
            props.actionsSujet.setAgencyInfoPanelVisibility(value);
          }}
          agencyInfoPanelVisibility={props.userDataEC.agencyInfoPanelVisibility}
          isAgencyJourney={props.userDataEC.isAgencyJourney}
          agencyData={props.userDataEC.agencyData}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    dispatch: dispatch,
    actionsFilters: bindActionCreators(_actionsFilters, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Step2)));
